<template>
  <div class="retail-hotel-index-container">
    <transition
      name="fade"
    >
      <div
        v-if="this.$store.state.hotel.retailLoading"
        class="retail-hotels-load"
      />
    </transition>
    <div class="retail-hotel-search">
      <HotelSearch />
    </div>
    <div class="retail-hotel-index">
      <div class="retail-hotel-filter-container">
        <HotelFilter />
      </div>
      <div class="retail-hotel-list">
        <div
          class="alert-container"
          :class="[ this.$store.state.hotel.hasFilterResults == false ? 'no-results' : '']"
        >
          <div class="alert-icon-container">
            <i class="fa fa-exclamation" />
          </div>
          <div class="alert-message-container">
            <div class="alert-message">
              <span>Your filter options are not showing a match.</span>
            </div>
            <div class="suggestion">
              <span>Try adjusting your filters or see more choices below.</span>
            </div>
          </div>
        </div>
        <IndexView />
        <div
          v-if="filteredHotels.length == 0"
          class="default-retail-list"
          :class="[ this.$store.state.hotel.showFilter == true ? 'filter-show' : '']"
        >
          <div class="overlay" />
          <RetailHotelCard
            v-for="hotel in retailHotels"
            :key="hotel.index"
            :hotel="hotel"
          />
        </div>
        <div
          v-else
          class="filtered-retail-list"
          :class="[ this.$store.state.hotel.showFilter == true ? 'filter-show' : '']"
        >
          <div class="overlay" />
          <RetailHotelCard
            v-for="hotel in filteredHotels"
            :key="hotel.index"
            :hotel="hotel"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HotelFilter from './retail_hotel_filter'
import HotelSearch from './hotel_search'
import IndexView from './index_view'
import RetailHotelCard from './retail_hotel_card'
import { mapGetters } from 'vuex'

export default {
  components: {
    HotelFilter,
    HotelSearch,
    IndexView,
    RetailHotelCard
  },

  computed: mapGetters('hotel', {
    retailHotels: 'getRetailHotels',
    filteredHotels: 'getFilteredHotels'
  }),
}
</script>
